var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserCogC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.15 23.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.93 1a5.23 5.23 0 11-5.21 5.22A5.22 5.22 0 0112.93 1m0-1a6.21 6.21 0 00-6.21 6.22 6.21 6.21 0 006.21 6.21 6.22 6.22 0 100-12.43z",
    fill: "#003a47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.63 14.86a23.36 23.36 0 00-3.7-.94 18.09 18.09 0 00-3-.28C8.78 13.64.5 15.82.5 20.15v3.26h24.56",
    stroke: "#003a47",
    strokeMiterlimit: 10,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.79 18.91a2.39 2.39 0 112.37-2.41 2.38 2.38 0 01-2.37 2.41zm6.66-3.35l-1.87-.34A5.11 5.11 0 0031 14l1.05-1.58a.23.23 0 000-.29l-1-.94a.21.21 0 00-.28 0l-1.52 1.01a4.89 4.89 0 00-1.25-.51l-.38-1.87a.23.23 0 00-.22-.18l-1.4.02a.22.22 0 00-.22.18l-.34 1.87a5.52 5.52 0 00-1.27.54l-1.56-1.05a.23.23 0 00-.28 0l-.95 1a.21.21 0 000 .28l1.09 1.57a4.69 4.69 0 00-.51 1.27l-1.87.38a.23.23 0 00-.18.22v1.36a.22.22 0 00.18.21l1.87.34a5.52 5.52 0 00.54 1.27l-1 1.58a.24.24 0 000 .29l1 .94a.22.22 0 00.28 0l1.57-1.09a4.69 4.69 0 001.27.51L26 23.2a.23.23 0 00.22.18h1.36a.22.22 0 00.22-.18l.33-1.87a5.52 5.52 0 001.27-.54l1.59 1.05a.23.23 0 00.28 0l.95-1a.23.23 0 000-.28L31.09 19a5.06 5.06 0 00.52-1.27l1.86-.38a.22.22 0 00.18-.22v-1.36a.23.23 0 00-.2-.21z",
    fill: "#addccd",
    stroke: "#003a47",
    strokeMiterlimit: 10
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCogC);
export default __webpack_public_path__ + "static/media/user-cog-c.202988c8.svg";
export { ForwardRef as ReactComponent };